export const ITCAdderCodes = {
  DOMESTIC_CONTENT: 'DOMESTIC_CONTENT',
  ENERGY_COMMUNITY: 'ENERGY_COMMUNITY',
  LOW_INCOME_COMMUNITY_TRIBAL: 'LOW_INCOME_COMMUNITY_TRIBAL',
  LOW_INCOME_ECONOMIC_BENEFIT: 'LOW_INCOME_ECONOMIC_BENEFIT'
};